import { actionTypes } from '../actions/notify.action';

const initialState = {
    open: false,
    horizontal: 'right',
    vertical: 'top',
    class: 'success',
    time: 4000,
    msg: 'Dados Atualizados',
}

// eslint-disable-next-line
export default (state = initialState, {type, payload}) => {
  switch (type) {

  case actionTypes.CHANGE:
    return { ...state, ...payload };

  default:
    return state
  }
};
